import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, Router } from '@angular/router'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { EMPTY, Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { StorageGroup } from './storage-group'
import { StorageGroupService } from './storage-group.service'

@Injectable({ providedIn: 'root' })
export class StorageGroupResolver {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private router = inject(Router)
  private storageGroupService = inject(StorageGroupService)
  private toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  resolve(route: ActivatedRouteSnapshot): Observable<StorageGroup> {
    const id = route.paramMap.get('id')

    return this.storageGroupService.findById(id).pipe(
      catchError((err) => {
        this.toastService.error('Failed to load StorageGroup', null, err)
        this.router.navigate(['app/storage-groups'])
        return EMPTY
      })
    )
  }
}
